export const SCHEDULE = 'schedule'
